import { Injectable } from '@angular/core';
import { Session } from 'src/app/interface/session/session';
import { SessionCode } from 'src/app/enums/session/session-code.enum';
import { SessionKey } from 'src/app/enums/session/session-key.enum';

@Injectable({
  providedIn: 'root'
})
export class OrganizationSession implements Session
{
    constructor() { }

    get(): string | SessionCode
    {
        try{
            const org = localStorage.getItem( SessionKey.ORGANIZATION ) 

            if (!org) return SessionCode.MISSING_VALUE

            return org            
        }catch(error)
        {
            return SessionCode.GENERIC
        }
    }

    set(org : string): SessionCode
    {
        if(!org) return  SessionCode.INVALID_INPUT

        try{
            localStorage.setItem( SessionKey.ORGANIZATION, org ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }

    clear(): SessionCode
    {
        try{
            localStorage.removeItem( SessionKey.ORGANIZATION ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }
}

